import isObject from 'lodash/isObject';
import multiRegionModules from 'Shared/utils/multiRegionInfo';

const REGION_INFO: any = {};
multiRegionModules.keys().forEach((fileName: string) => {
  // Add info of each region into the REGION_INFO
  Object.assign(REGION_INFO, multiRegionModules(fileName));
});

export function getRegion(hostname: string) {
  const isLocalhost = hostname.includes('localhost');
  if (hostname.includes('systems')) return 'VN';
  return isLocalhost
    ? __REGION__
    : hostname.substr(-2).toUpperCase();
}

export function getCurRegion() {
  return getRegion(window.location.hostname);
}

/* APIs to get certain region info */
export function getRegionInfo(region: any, path = '') {
  const info: { [key: string]: any } = REGION_INFO[region];
  if (typeof path !== 'string') return;
  if (!info) {
    throw new Error('No information for the region: ', region);
  }

  const paths: string[] = path.split('.');
  let data: { [key: string]: any } | undefined = info;
  while (paths.length) {
    if (!isObject(data)) {
      data = undefined;
      return;
    }
    data = (data as { [key: string]: any })[paths.shift() as string];
  }
  return data;
}

export function getLocalInfo(path: string) {
  return getRegionInfo(getCurRegion(), path);
}

export const reverseCopyAddressHierachy = (source: any = {}): any => {
  const { parent, ...hierachyInfo } = source;
  if (parent) {
    parent.children = hierachyInfo;
    return [...reverseCopyAddressHierachy(parent), hierachyInfo];
  } else {
    return [hierachyInfo];
  }
};
